function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  query ValidateCouponQuery(\n    $code: String!\n    $dispensaryId: String!\n    $isReapplying: Boolean\n    $orderSubtotalInCents: Int!\n    $products: [couponValidationProductInput]\n  ) {\n    validateCouponQuery(\n      code: $code\n      dispensaryId: $dispensaryId\n      isReapplying: $isReapplying\n      orderSubtotalInCents: $orderSubtotalInCents\n      products: $products\n    ) {\n      coupon {\n        _id\n        applicableCategories {\n          category\n          subcategory\n        }\n        code\n        dispensaryId\n        expDate\n        fixedDiscountInCents\n        percentDiscount\n        restrictions {\n          minimumPurchase\n          minimumPurchaseInCents\n          noSpecials\n        }\n        usedBy\n      }\n      isValid\n      message\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import gql from 'graphql-tag';
export var validateCouponQuery = gql(_templateObject());
